import useLocalStorage from '../utils/useLocalStorage';

function useMarkupSettings() {
  const [showHoleGuides, setShowHoleGuides] = useLocalStorage('showHoleGuides', false);
  const [numberOfHoles, setNumberOfHoles] = useLocalStorage('numberOfHoles', 5);
  const [showFoldLine, setShowFoldLine] = useLocalStorage('showFoldLine', false);
  const [showPageNumbers, setShowPageNumbers] = useLocalStorage('showPageNumbers', false);
  const [showPageImages, setShowPageImages] = useLocalStorage('showPageImages', true);
  const [showOutputPageNumbers, setShowOutputPageNumbers] = useLocalStorage('showOutputPageNumbers', false);
  const [pageNumberOffset, setPageNumberOffset] = useLocalStorage('pageNumberOffset', 0);
  const [pageNumberFontSize, setPageNumberFontSize] = useLocalStorage('pageNumberFontSize', 4);

  return {
    showHoleGuides, setShowHoleGuides,
    numberOfHoles, setNumberOfHoles,
    showFoldLine, setShowFoldLine,
    showPageNumbers, setShowPageNumbers,
    showPageImages, setShowPageImages,
    showOutputPageNumbers, setShowOutputPageNumbers,
    pageNumberOffset, setPageNumberOffset,
    pageNumberFontSize, setPageNumberFontSize,
  };
}

export default useMarkupSettings;
